/**
 * Animations are rendered here
 * 
 * 
 */

import gsap from 'gsap';
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

// Hero Download Arrow
const downArrow = document.querySelector('button.down-arrow');
if(downArrow){
  downArrow.addEventListener('click', function(){
      document.querySelector('.hero-wrap ~ *').scrollIntoView({behavior: 'smooth'});
  });
}

// Animate elements in
const animatedEls = document.querySelectorAll('.animated-entrance');

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    let offset = '-10px', polygonInitial = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)', polygon = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
    if(entry.boundingClientRect.left > window.innerWidth/3){
      offset = '100px', polygonInitial = 'polygon(100% 0, 100% 0%, 100% 100%, 100% 100%)', polygon = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
    }
    if (entry.intersectionRatio > 0) {
      gsap.set(entry.target, {clipPath: polygonInitial});
      gsap.to(entry.target, {delay: 0.2, opacity: 1, clipPath: polygon, ease: "power2.out", duration: 1});
    } else {
      gsap.set(entry.target, {delay: 0.1, opacity: 0, clipPath: polygonInitial});
    }
  });
});

animatedEls.forEach(image => {
  observer.observe(image); 
});